var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page bg-white" },
    [
      _c("vxe-toolbar", {
        attrs: {
          refresh: { query: _vm.refreshList },
          export: "",
          print: "",
          custom: "",
        },
        scopedSlots: _vm._u([
          {
            key: "buttons",
            fn: function () {
              return [
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "danger",
                      size: "small",
                      icon: "el-icon-delete",
                      disabled:
                        _vm.$refs.runningTable &&
                        _vm.$refs.runningTable.getCheckboxRecords().length ===
                          0,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.del()
                      },
                    },
                  },
                  [_vm._v("作废 ")]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "div",
        { staticStyle: { height: "calc(100% - 80px)" } },
        [
          _c(
            "vxe-table",
            {
              ref: "runningTable",
              attrs: {
                border: "inner",
                "auto-resize": "",
                resizable: "",
                height: "auto",
                loading: _vm.loading,
                size: "small",
                "show-header-overflow": "",
                "show-overflow": "",
                "highlight-hover-row": "",
                "menu-config": {},
                "print-config": {},
                "import-config": {},
                "export-config": {},
                data: _vm.dataList,
                "checkbox-config": {},
              },
            },
            [
              _c("vxe-column", { attrs: { type: "seq", width: "40" } }),
              _c("vxe-column", { attrs: { type: "checkbox", width: "40px" } }),
              _c("vxe-column", {
                attrs: { title: "标题", field: "vars.title" },
              }),
              _c("vxe-column", {
                attrs: { title: "流程名称", field: "processDefinitionName" },
              }),
              _c("vxe-column", {
                attrs: { title: "当前节点", field: "taskName" },
              }),
              _c("vxe-column", {
                attrs: { title: "流程状态", field: "status" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: scope.row.level,
                              effect: "dark",
                              size: "small",
                            },
                          },
                          [_vm._v(_vm._s(scope.row.status) + " ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("vxe-column", {
                attrs: { title: "流程发起人", field: "vars.userName" },
              }),
              _c("vxe-column", {
                attrs: {
                  title: "操作",
                  width: "150px",
                  type: "html",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.detail(scope.row)
                              },
                            },
                          },
                          [_vm._v("详情 ")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.trace(scope.row)
                              },
                            },
                          },
                          [_vm._v("进度 ")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.del(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("作废 ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("vxe-pager", {
            attrs: {
              background: "",
              size: "small",
              "current-page": _vm.tablePage.currentPage,
              "page-size": _vm.tablePage.pageSize,
              total: _vm.tablePage.total,
              "page-sizes": [
                10,
                20,
                100,
                1000,
                { label: "全量数据", value: 1000000 },
              ],
              layouts: [
                "PrevPage",
                "JumpNumber",
                "NextPage",
                "FullJump",
                "Sizes",
                "Total",
              ],
            },
            on: { "page-change": _vm.currentChangeHandle },
          }),
          _c(
            "el-dialog",
            {
              directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
              attrs: {
                title: "查看进度",
                "close-on-click-modal": true,
                visible: _vm.visible,
                width: "70%",
                height: "600px",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.visible = $event
                },
              },
            },
            [
              _c("flow-chart", {
                ref: "preview",
                attrs: { processInstanceId: _vm.processInstanceId },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }